import React from 'react';
import { Navigate, Outlet, RouteObject } from 'react-router';

import { utils as commonUtils } from '@finley-technologies/common';

import { Route as DevHomeRoute } from '~/core/routes/dev/_index';
import { Route as ChakraAlertRoute } from '~/core/routes/dev/chakra/Alert/_index';
import { Route as ChakraButtonRoute } from '~/core/routes/dev/chakra/Button/_index';
import { Route as ChakraIconButtonRoute } from '~/core/routes/dev/chakra/IconButton/_index';
import { Route as ChakraProgressRoute } from '~/core/routes/dev/chakra/Progress/_index';
import { Route as ChakraStepperRoute } from '~/core/routes/dev/chakra/Stepper/_index';
import { Route as IconButtonV2Route } from '~/core/routes/dev/common-frontend/IconButtonV2/_index';
import { Route as LayoutRoute } from '~/core/routes/dev/common-frontend/layout/Layout/_index';
import { Route as MenuTreeRoute } from '~/core/routes/dev/common-frontend/MenuTree/_index';
import { Route as TableRoute } from '~/core/routes/dev/common-frontend/tables/Table/_index';
import { Route as TimestampRoute } from '~/core/routes/dev/common-frontend/Timestamp/_index';
import { Route as TypographyRoute } from '~/core/routes/dev/common-frontend/Typography/_index';
import { Route as UserDetailRoute } from '~/core/routes/dev/common-frontend/UserDetail/_index';

// Fragments
const RouteBase = () => {
  if (commonUtils.EnvUtils.isProduction()) return <Navigate to="/" replace />;

  return <Outlet />;
};

// Exports
export const Router: RouteObject = {
  element: <RouteBase />,
  children: [
    { index: true, element: <DevHomeRoute /> },
    { path: 'chakra/Alert', element: <ChakraAlertRoute /> },
    { path: 'chakra/Button', element: <ChakraButtonRoute /> },
    { path: 'chakra/IconButton', element: <ChakraIconButtonRoute /> },
    { path: 'chakra/Progress', element: <ChakraProgressRoute /> },
    { path: 'chakra/Stepper', element: <ChakraStepperRoute /> },
    { path: 'common-frontend/layout/Layout', element: <LayoutRoute /> },
    { path: 'common-frontend/tables/Table', element: <TableRoute /> },
    { path: 'common-frontend/IconButtonV2', element: <IconButtonV2Route /> },
    { path: 'common-frontend/MenuTree', element: <MenuTreeRoute /> },
    { path: 'common-frontend/Timestamp', element: <TimestampRoute /> },
    { path: 'common-frontend/Typography', element: <TypographyRoute /> },
    { path: 'common-frontend/UserDetail', element: <UserDetailRoute /> },
    { path: '*', element: <Navigate to="./" replace /> },
  ],
};
